import { BulkEditCboxState, productosAPI } from "API/productos";
import {
  OverlayStructure,
  /*  Spinner, */
} from "components/styles/smallComponents";
import {
  AllowedMethodsForPriceModification,
  BULK_EDIT_FULL_OPTIONS,
  BULK_EDIT_UNITS,
  BulkEditOptionsTypeAndEmptyString,
  MethodForPriceModification,
} from "Theconstants";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import {
  Btn,
  Line,
  MainHeader,
  SubContainer,
} from "pages/admin/auxiliaries/OverlayStyledComp";

const FlexIt = styled.div`
  display: flex;
  align-items: center;
  /* styling stock, price and promo inputs/select */
  & input,
  & select {
    padding: 10px;
  }
`;
const PromoControllers = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  & input[type="number"] {
    width: 100%;
  }
`;
const FlexColumn = styled(SubContainer)`
  flex-direction: column;
  display: flex;
  gap: 5px;
`;

const Capitalize = styled.b`
  text-transform: capitalize;
  font-size: var(--fontMed);
`;

type Props = {
  bulkData: BulkEditCboxState;
  show: boolean;
  close: () => void;
  type: BulkEditOptionsTypeAndEmptyString;
};
const BulkEditOverlay = ({ close, show, bulkData, type }: Props) => {
  const dispatch = useDispatch();
  let translatedText = "";

  if (type.includes(BULK_EDIT_FULL_OPTIONS.PRECIO_ADD)) {
    translatedText = "aumentar el precio";
  } else if (type.includes(BULK_EDIT_FULL_OPTIONS.PRECIO_SUBTRACT)) {
    translatedText = "disminuir el precio";
  } else if (type.includes(BULK_EDIT_FULL_OPTIONS.PROMO)) {
    translatedText = "modificar la promo";
  } else if (type.includes(BULK_EDIT_FULL_OPTIONS.DESTACADO)) {
    translatedText = "modificar el 'destacado'";
  } else {
    translatedText = "modificar el stock";
  }
  const [weirdUntypedValue, setWeirdUntypedValue] =
    useState</* esto no funciona en los inputs defaultState sin agregar codigo adicional, asi q por ahora lo comento y dejo any string | number | boolean | null */ any>();
  const [promo, setPromo] = useState(true);
  const [priceEditType, setPriceEditType] =
    useState<MethodForPriceModification>(BULK_EDIT_UNITS.PRECIO_PERCENTAGE);

  useEffect(() => {
    //pongo el value como true, asi el input puede estar checked
    if (type.includes(BULK_EDIT_FULL_OPTIONS.DESTACADO)) {
      setWeirdUntypedValue(true);
    }
  }, [type]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    productosAPI
      .bulkUpdate(dispatch, bulkData, {
        type: type.includes(BULK_EDIT_UNITS.PRECIO)
          ? //'+precio' + editType
            //'-precio' + editType
            type + priceEditType
          : type,
        /*      | "destacado"
  | "promo"
  | "stock" */

        //si la promo esta en modo false con el null value le aviso al backend q quite la promo
        value:
          type.includes(BULK_EDIT_FULL_OPTIONS.PROMO) && !promo
            ? null
            : weirdUntypedValue,
      })
      .then(() => {
        //TODO: ver xq carajo esto es boolean y string a la vez,capaz deberìa poner false en vez de empty string, creo lo uso p/diferentes inputs de admin, me pa q solo boolean no va. Usar union. Deje unos comentarios arriba tmb
        setWeirdUntypedValue("");
        close();
      })
      .catch(() => {});
  };

  return (
    <OverlayStructure close={close} show={show}>
      <MainHeader>EDICION MASIVA DE PRODUCTOS</MainHeader>
      <Line />
      <form onSubmit={handleSubmit}>
        <FlexColumn>
          <Capitalize>{type}</Capitalize>
          <div>{`Vas a ${translatedText} en ${
            bulkData.filter(
              (i) => i.checked || i.esp.some((espSingle) => espSingle.checked)
            ).length
          } producto/s.`}</div>
          <FlexIt>
            {type.includes(BULK_EDIT_UNITS.PRECIO) ? (
              <>
                <select
                  value={priceEditType}
                  onChange={(e) => {
                    if (
                      AllowedMethodsForPriceModification.includes(
                        //@ts-ignore
                        e.target.value
                      )
                    )
                      //@ts-ignore
                      setPriceEditType(e.target.value);
                  }}
                >
                  {AllowedMethodsForPriceModification.map((method) => {
                    return (
                      <option value={method} key={method}>
                        {method}
                      </option>
                    );
                  })}
                </select>

                <input
                  type={"number"}
                  min={1}
                  value={weirdUntypedValue}
                  placeholder="Agregar precio..."
                  onChange={({ target }) => setWeirdUntypedValue(target.value)}
                />
              </>
            ) : type.includes(BULK_EDIT_FULL_OPTIONS.STOCK) ? (
              <>
                <span>+</span>{" "}
                <input
                  type={"number"}
                  value={weirdUntypedValue}
                  //minimo stock 0
                  min={0}
                  placeholder="Establecer nuevo stock..."
                  onChange={({ target }) => setWeirdUntypedValue(target.value)}
                />
              </>
            ) : type.includes(BULK_EDIT_FULL_OPTIONS.DESTACADO) ? (
              <div style={{ width: "100%" }}>
                <h3>Marcá la casilla para destacar el producto.</h3>
                <br />
                <PromoControllers>
                  <input
                    autoFocus
                    type="checkbox"
                    checked={weirdUntypedValue}
                    style={{ height: "2rem" }}
                    onChange={() => setWeirdUntypedValue((v) => !v)}
                  ></input>

                  <b>{weirdUntypedValue ? "DESTACADO" : "Sin destacar"}</b>
                </PromoControllers>
              </div>
            ) : (
              /*----------------- PROMO------------------- */
              <div style={{ width: "100%" }}>
                <h3>Marcá la casilla para poner en promoción</h3>
                <br />
                <PromoControllers>
                  <input
                    autoFocus
                    type="checkbox"
                    checked={promo}
                    style={{ height: "2rem" }}
                    onChange={() => setPromo((v) => !v)}
                  ></input>

                  <b>{promo ? "En promoción" : "Sin promoción"}</b>
                  {!!promo && (
                    <input
                      type="number"
                      value={weirdUntypedValue}
                      min={1}
                      max={100}
                      onChange={({ target }) =>
                        setWeirdUntypedValue(target.value)
                      }
                      placeholder="% de la promo"
                    ></input>
                  )}
                </PromoControllers>
              </div>
            )}
          </FlexIt>
        </FlexColumn>
        <Line />
        <SubContainer flexIt>
          <Btn
            danger
            onClick={(e) => {
              e.preventDefault();
              close();
            }}
            /*   disabled={indLoading} */
          >
            Cancelar
          </Btn>
          <Btn
          /* disabled={indLoading} */
          >
            CONFIRMAR
            {/*   {indLoading ? <Spinner fz="var(--fontSmall)" /> : "Confirmar"} */}
          </Btn>
        </SubContainer>
      </form>
    </OverlayStructure>
  );
};

export default BulkEditOverlay;
